import { applyDebugIp } from './debugIpOverride';
import { getDeviceHeaders } from './sessionStore';

/**
 * Headers of a form-encoded call to an OAuth endpoint: the device id, the simulated IP of the debug
 * panel and the Basic credentials of the client application. Shared by the login and the refresh.
 * @param {{user: string, password: string}} credentials - Credentials of the backend's OAuth client.
 * @returns {object} The headers to send.
 * @author armandoricosandoval -ai-
 */
export const buildOAuthFormHeaders = ({ user, password }) =>
  applyDebugIp({
    ...getDeviceHeaders(),
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Basic ${btoa(`${user}:${password}`)}`
  });
